<template>
  <div class="text-center error-wrapper">
    <AppToolbar title="Error"></AppToolbar>
    <div>
      <img src="../../assets/generic-error.png" alt="Error" class="mb-4" />
      <h1 class="headline primary--text">Something wrong here...</h1>
      <p class="subheading">
        Sorry, we're having some technical issues (as you can see)
        <br />
        Try to refresh the page, sometime works ;)
      </p>
    </div>
  </div>
</template>

<script>
import AppToolbar from '@/components/AppToolbar'

export default {
  components: {
    AppToolbar
  },

  created() {
    this.$store.commit('mapSetShow', false)
    this.$emit('toolbarTitleChange', 'Error')
  }
}
</script>

<style lang="scss" scoped>
.error-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 80%;
  }
}
</style>
